module.exports = __webpack_public_path__ + "img/icon-imgdl.349f4854.svg";